import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginatedResponse } from 'app/_models/paginated-data.model';
import { Pagination } from 'app/_models/pagination.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs-compat';
import { catchError } from 'rxjs/operators';
import { BaseHttpClientService } from './base-http-client.service';

@Injectable()
export class AssetAvailabilityScheduleService extends BaseHttpClientService {
  constructor(
    private http: HttpClient,
  ) {
    super()
  }

  public createAvailabilityItem(body): Observable<any> {
    return this.http.post(environment.apiUrl + 'api/ext-asset-availability', body)
      .pipe(catchError(this.handleError));
  }

  public editAvailabilityItem(id, body): Observable<any> {
    return this.http.put(environment.apiUrl + 'api/ext-asset-availability/' + id, body)
      .pipe(catchError(this.handleError));
  }

  public deleteAvailabilityItem(id): Observable<any> {
    return this.http.delete(environment.apiUrl + 'api/ext-asset-availability/' + id)
      .pipe(catchError(this.handleError));
  }

  public getAllAvailabilityItems(assetId: string, pagination: Pagination, filter: { key: string; value: string; }[]): Observable<PaginatedResponse<any>> {
    const params = this.createQueryStrings(pagination, undefined, filter);
    const headers = this.applyLatestOnlyHeader();

    return (this.http.get(environment.apiUrl + 'api/ext-asset-availability/by-asset/' + assetId, { params, observe: 'response', headers }) as any)
      .pipe(catchError(this.handleError));
  }

  public getAllAvailabilityItemsBySite(siteId: string, filter: { key: string; value: string; }[]): Observable<any> {
    const params = this.createQueryStrings(undefined, undefined, filter);
    const headers = this.applyLatestOnlyHeader();

    return (this.http.get(environment.apiUrl + 'api/ext-asset-availability/all-by-site/' + siteId, { params, headers }) as any)
      .pipe(catchError(this.handleError));
  }
  public getAllAvailabilityItemsBySiteOwner(siteOwnerId: number, filter: { key: string; value: string; }[]): Observable<any> {
    const params = this.createQueryStrings(undefined, undefined, filter);
    const headers = this.applyLatestOnlyHeader();

    return (this.http.get(environment.apiUrl + 'api/ext-asset-availability/all-by-site-owner/' + siteOwnerId, { params, headers }) as any)
      .pipe(catchError(this.handleError));
  }
}
